import PropTypes from "prop-types";
import SavedItemsProductTileList from "../../../../../../containers/common/SavedItemsProductTileList";
import SavedTilesCollection from "./SavedTilesCollection";
import isLastBestPriceEnabled from "../../../../../common/SavedItemsProductTiles/isLastBestPriceEnabled";
import { isFullyLoaded } from "../../../../../../../state/modules/savedItems/selectors/itemStateSelectors";
import useHandleResize from "./useHandleResize";
import AppDownloadBanner from "../../../../../common/AppDownloadBanner";
import useMatchMedia from "../../../../../common/useMatchMedia";
import media from "../../../../../../../styles/customMedia.json";
import webContextProvider from "../../../../../../../providers/webContextProvider";
import { isTablet } from "../../../utils";

const SavedItemsProductTiles = ({
  savedItems,
  ProductTile,
  showDiscountLabel,
  isAuthenticated
}) => {
  const {
    customMedia: { ["--large-viewport"]: largeViewport }
  } = media;

  const showExtendedPricing = isLastBestPriceEnabled();
  const { adPosition } = useHandleResize();
  const isLargeViewport = useMatchMedia(largeViewport);
  const { platform } = webContextProvider();
  const isTab = isTablet();

  return (
    <>
      <SavedItemsProductTileList>
        <SavedTilesCollection
          ProductTile={ProductTile}
          savedItems={savedItems}
          showDiscountLabel={showDiscountLabel}
          showExtendedPricing={showExtendedPricing}
          isAuthenticated={isAuthenticated}
          isFullyLoaded={isFullyLoaded}
          adPosition={adPosition}
        />
        {savedItems.length > 0 && (
          <>
            {isLargeViewport && platform === "desktop" && !isTab && (
              <li>
                <AppDownloadBanner />
              </li>
            )}
          </>
        )}
      </SavedItemsProductTileList>
    </>
  );
};

SavedItemsProductTiles.propTypes = {
  ProductTile: PropTypes.elementType.isRequired,
  savedItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      variants: PropTypes.array
    }).isRequired
  ),
  showDiscountLabel: PropTypes.bool.isRequired,
  isAuthenticated: PropTypes.bool.isRequired
};

export default SavedItemsProductTiles;
